export default __webpack_public_path__ + "static/media/porcelain-pavers-banner.6697eb8f.jpg";